import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import LogIn from "../components/auth/LogIn";
import Register from "../components/auth/Register";
import ForgotPassword from "../components/auth/ForgotPassword";
import ForgotPasswordVerification from "../components/auth/ForgotPasswordVerification";
import ChangePassword from "../components/auth/ChangePassword";
import ChangePasswordConfirm from "../components/auth/ChangePasswordConfirm";
import Welcome from "../components/auth/Welcome";
import Adminlogin from "../components/auth/Adminlogin";

const AuthRoutes = ({ isUserAuthenticated, authProps }) => {
    return (
        <>
            <Route
                exact
                path="/login"
                render={() => isUserAuthenticated() ? <Redirect to="/" /> : <LogIn />}
            />
            <Route
                exact
                path="/register"
                render={(props) => <Register {...props} auth={authProps} />}
            />
            <Route
                exact
                path="/forgotpassword"
                render={(props) => <ForgotPassword {...props} auth={authProps} />}
            />
            <Route
                exact
                path="/forgotpasswordverification"
                render={(props) => <ForgotPasswordVerification {...props} auth={authProps} />}
            />
            <Route
                exact
                path="/changepassword"
                render={() => isUserAuthenticated() ? <ChangePassword /> : <Redirect to="/login" />}
            />
            <Route
                exact
                path="/changepasswordconfirmation"
                render={() => isUserAuthenticated() ? <ChangePasswordConfirm /> : <Redirect to="/login" />}
            />
            <Route
                exact
                path="/welcome"
                render={(props) => <Welcome {...props} auth={authProps} />}
            />
            <Route
                exact
                path="/admin-login"
                render={(props) => <Adminlogin {...props} auth={authProps} />}
            />
        </>
    );
};

export default AuthRoutes;
